/* House of Trees — global.js */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    var format = window.shopMoneyFormat || '€{{amount_with_comma_separator}}';
    var value = (cents / 100).toFixed(2);
    var withComma = value.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var plain = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withComma.split(',')[0])
      .replace(/\{\{\s*amount\s*\}\}/, plain)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, plain.split('.')[0]);
  }
  window.formatMoney = formatMoney;

  /* ---------- drawers (menu / cart) ---------- */
  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = document.getElementById(btn.getAttribute('data-drawer-open'));
      if (!drawer) return;
      drawer.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      var focusable = drawer.querySelector('button, a, input');
      if (focusable) focusable.focus();
    });
  });
  function closeDrawer(drawer) {
    drawer.removeAttribute('open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('.drawer').forEach(function (drawer) {
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeDrawer(drawer); });
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.drawer[open]').forEach(closeDrawer);
  });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- toast ---------- */
  var toast = document.getElementById('Toast');
  var toastTimer;
  window.showToast = function (html) {
    if (!toast) return;
    toast.querySelector('[data-toast-body]').innerHTML = html;
    toast.setAttribute('data-open', '');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.removeAttribute('data-open'); }, 4500);
  };

  /* ---------- cart count ---------- */
  window.updateCartCount = function (count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };

  /* ---------- quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var next = parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.min || '1', 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product form (variant + add to cart) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (wrap) {
    var variants = JSON.parse(wrap.querySelector('[data-variants]').textContent);
    var idInput = wrap.querySelector('[name="id"]');
    var priceEl = wrap.querySelector('[data-price]');
    var compareEl = wrap.querySelector('[data-compare-price]');
    var button = wrap.querySelector('[data-add-to-cart]');
    var buttonText = button ? button.querySelector('[data-add-to-cart-text]') : null;
    var form = wrap.querySelector('form[action*="/cart/add"]');

    function selectedOptions() {
      return Array.prototype.map.call(wrap.querySelectorAll('[data-option-index]'), function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) return checked.value;
        var select = group.querySelector('select');
        return select ? select.value : null;
      });
    }
    function findVariant() {
      var opts = selectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function render() {
      var v = findVariant();
      if (!v) {
        if (button) { button.disabled = true; if (buttonText) buttonText.textContent = window.themeStrings.unavailable; }
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (button) {
        button.disabled = !v.available;
        if (buttonText) buttonText.textContent = v.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
      }
      var label = wrap.querySelector('[data-selected-value]');
      if (label) label.textContent = v.title;
      if (history.replaceState && wrap.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    /*wrap.querySelectorAll('[data-option-index] input, [data-option-index] select').forEach(function (el) {
      el.addEventListener('change', render);
    });
    render();*/

  });

  /* ---------- cart page ---------- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    function changeLine(line, quantity) {
      return fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () { window.location.reload(); });
    }
    cartForm.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]');
      if (input) changeLine(input.getAttribute('data-line-qty'), parseInt(input.value, 10));
    });
    cartForm.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-line-remove]');
      if (btn) { e.preventDefault(); changeLine(btn.getAttribute('data-line-remove'), 0); }
    });

    /* delivery date: persisted as cart attribute */
    var dateInput = cartForm.querySelector('[name="attributes[Bezorgdatum]"]');
    var regionSelect = cartForm.querySelector('[name="attributes[Bezorgregio]"]');
    var errorEl = cartForm.querySelector('[data-delivery-error]');
    var checkoutBtn = cartForm.querySelector('[name="checkout"]');
    function saveAttributes() {
      var attrs = {};
      if (dateInput) attrs.Bezorgdatum = dateInput.value;
      if (regionSelect) attrs.Bezorgregio = regionSelect.value;
      return fetch(window.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      });
    }
    if (dateInput) dateInput.addEventListener('change', saveAttributes);
    if (regionSelect) regionSelect.addEventListener('change', saveAttributes);
    if (checkoutBtn && dateInput && dateInput.required) {
      cartForm.addEventListener('submit', function (e) {
        if (!dateInput.value) {
          e.preventDefault();
          if (errorEl) errorEl.style.display = 'block';
          dateInput.focus();
        }
      });
    }
  }

  /* ---------- initial cart count ---------- */
  fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
    window.updateCartCount(cart.item_count);
  }).catch(function () {});
})();

/* ---------- sneeuw over de hele site (canvas, licht) ---------- */
(function () {
  var canvas = document.getElementById('SnowCanvas');
  if (!canvas || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ctx = canvas.getContext('2d'), flakes = [], w, h, raf;
  var COUNT = Math.min(110, Math.floor(window.innerWidth / 12));
  function resize() { w = canvas.width = window.innerWidth; h = canvas.height = window.innerHeight; }
  function make(y) {
    return { x: Math.random() * w, y: y === undefined ? Math.random() * h : y, r: 1 + Math.random() * 2.6, s: .4 + Math.random() * .9, d: Math.random() * Math.PI * 2, a: .35 + Math.random() * .45 };
  }
  function tick() {
    ctx.clearRect(0, 0, w, h);
    for (var i = 0; i < flakes.length; i++) {
      var f = flakes[i];
      f.y += f.s; f.d += .01; f.x += Math.sin(f.d) * .4;
      if (f.y > h + 5) flakes[i] = make(-5);
      ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255, 250, 240, ' + f.a + ')'; ctx.fill();
    }
    raf = requestAnimationFrame(tick);
  }
  resize(); for (var i = 0; i < COUNT; i++) flakes.push(make());
  window.addEventListener('resize', resize);
  document.addEventListener('visibilitychange', function () { if (document.hidden) cancelAnimationFrame(raf); else tick(); });
  tick();
})();
